
import React from 'react'
import { withRouter } from 'react-router-dom'
import { compose } from 'recompose'
import { translate } from 'react-switch-lang'
import { Container, Form, Grid } from 'semantic-ui-react'
// import Slider from 'react-slick'

import MyPage from '../../core/components/MyPage'
import LayoutWithHeaderFooter from '../layout/LayoutWithHeaderFooter'

import ButtonModel from '../../core/model/ButtonModel'
import ViewButton from '../../core/view/common/ViewButton'
import ViewHeader from '../layout/ViewHeader'
import ViewFooter from '../layout/ViewFooter'

import ItemRoom from '../room/ItemRoom'
import CreateUpdateEventForm from './CreateUpdateEventForm'
// import moment from 'moment'
// import RoomModel from '../../models/RoomModel'
import CreateUpdateEventModel from '../../models/CreateUpdateEventModel'
import FrontendSettingModel from '../../models/FrontendSettingModel'
import { cookiesKey, defaultValue } from '../../constant'
import ModalCreateUpdateEventSuccess from './ModalCreateUpdateEventSuccess'
import EventModel from '../../models/EventModel'

class ViewUpdateEvent extends MyPage {
    constructor(props) {
        super(props)
        this.state.user = this.bCookie.getData(cookiesKey.USER)
        this.state.isLoading = false
        this.state.eventId = this.getQueryFromProps("eventId")

        this.state.setting = null
        this.state.conferences = []
        this.state.rooms = []
        this.state.eventTypes = []
        this.state.eventRoomFormats = []
        this.state.model = null
        this.state.modelErrors = []
        // this.state.model = new CreateUpdateEventModel({
        //     startDateTime,
        //     endDateTime,
        //     eventRoomFormatId: defaultValue.NONE_SELECT
        // })
        this.state.isOpenModalUpdateSuccess = false
        this.state.responseEvent = null

        this.state.usersMailSystem = []
        this.state.userGroups = []
    }

    componentDidMount() {
        this.getData()
    }

    getData = () => {
        const { user, eventId } = this.state
        this.setState({
            isLoading: true
        }, async () => {
            let tempState = {
                isLoading: false,
                // setting: null,
                // model: model,
                // rooms: [],
                // eventTypes: [],
                // eventRoomFormats: [],
                // usersMailSystem: [],
                // userGroups: [],
            },
                action = () => {

                }
            let updateEventModel = null
            let resEventInfo = await this.props.onGetEventInfo(user.email, eventId)
            if (!!resEventInfo && resEventInfo.result === true && resEventInfo.data instanceof EventModel) {
                updateEventModel = new CreateUpdateEventModel({
                    eventRoomFormatId: defaultValue.NONE_SELECT
                })
                updateEventModel.setDataUpdate(resEventInfo.data)
                tempState.rooms = updateEventModel.rooms
                // tempState.model = updateEventModel
            }

            if (!!updateEventModel) {
                let [
                    resSetting,
                    resConference,
                    resEventType,
                    resRoomFormat,
                    resUserMailSystem,
                    resUserGroupList,
                ] = await Promise.all([
                    this.props.onGetSetting(),
                    this.props.onGetConferenceList(),
                    this.props.onGetEventType(),
                    this.props.onGetEventRoomFormat(),
                    this.props.onGetUserMailSystem(""),
                    this.props.onGetUserGroupList(),
                ])

                if (!!resSetting && resSetting.data instanceof FrontendSettingModel) {
                    tempState.setting = resSetting.data
                    updateEventModel.isEnableEventType = resSetting.data.isEnableEventType
                }
                if (!!resConference && Array.isArray(resConference.datas)) {
                    tempState.conferences = resConference.datas
                }
                if (!!resEventType && Array.isArray(resEventType.datas)) {
                    tempState.eventTypes = resEventType.datas
                }
                if (!!resRoomFormat && Array.isArray(resRoomFormat.datas)) {
                    tempState.eventRoomFormats = resRoomFormat.datas
                }

                if (!!resUserMailSystem && !!resUserMailSystem.result === true && Array.isArray(resUserMailSystem.datas)) {
                    tempState.usersMailSystem = resUserMailSystem.datas
                }
                if (!!resUserGroupList && !!resUserGroupList.result === true && Array.isArray(resUserGroupList.datas)) {
                    tempState.userGroups = resUserGroupList.datas
                }

                // let updateEventModel = new CreateUpdateEventModel(model)
                // updateEventModel.rooms = rooms
                // if (tempState.eventTypes.length > 0) {
                //     let findMeeting = tempState.eventTypes.find(e => e.code === eventTypeCreate.MEETING)
                //     if (!!findMeeting) {
                //         updateEventModel.eventTypeId = findMeeting.id
                //     } else {
                //         updateEventModel.eventTypeId = tempState.eventTypes[0].id
                //     }
                // }
                tempState.model = updateEventModel
            }

            this.setState(tempState, action)
        })
    }

    onUpdateEvent = () => {
        let { user, eventId, model, setting } = this.state
        this.setState({
            isLoading: true
        }, async () => {
            let tempState = {
                isLoading: false,
                responseEvent: null,
            },
                action = () => { }
            let res = await this.props.onUpdateEvent(eventId, model.organizerAddress, model.serializeAPI(user, setting))
            if (!!res && !!res.data) {
                tempState.responseEvent = res.data
                // tempState.isLoading = true
                tempState.isOpenModalUpdateSuccess = true
                // action = () => {
                // this.props.history.replace(`/event/create/success?eventId=${encodeURIComponent(red.data.eventId)}`)
                // }
            }
            this.setState(tempState, action)
        })
    }

    onClickView = () => {
        const { responseEvent } = this.state
        this.props.history.replace(`/event/view?eventId=${encodeURIComponent(responseEvent.eventId)}`)
    }

    onClickMyReservation = () => {
        this.props.history.replace(`/event/booking`)
    }

    render() {
        const { t } = this.props
        const { rooms, model, eventTypes, eventRoomFormats, isOpenModalUpdateSuccess, responseEvent, isLoading,
            usersMailSystem, userGroups, modelErrors, setting, conferences } = this.state

        let optionsEventType = eventTypes.map(d => d.serializeOption())
            , optionsEventRoomFormat = eventRoomFormats.map(d => d.serializeOption())
            , optionsConference = conferences.map(d => d.serializeOption())

        let isEvent = true
        if (!(model instanceof CreateUpdateEventModel)) {
            isEvent = false
        }
        return (
            <React.Fragment>
                {super.render()}
                {isLoading && this.getLoadingPage()}
                {
                    isOpenModalUpdateSuccess &&
                    <ModalCreateUpdateEventSuccess
                        model={responseEvent}
                        onClickView={this.onClickView}
                        onClickMyReservation={this.onClickMyReservation}
                    />
                }
                <LayoutWithHeaderFooter
                    header={<ViewHeader />}
                    footer={<ViewFooter />}
                >
                    <div className="module viewUpdateEvent">
                        <Container text>
                            <div className="update-event-header">
                                <h1>{t("event.bookingDetails")}</h1>
                            </div>
                            <div className="update-event-body">
                                <Form>
                                    <Grid>
                                        {
                                            isEvent &&
                                            <React.Fragment>
                                                <Grid.Row>
                                                    <Grid.Column width={16}>
                                                        <div className="location-box">
                                                            <p><b>{t("common.location")}</b></p>
                                                            <div className="room-list">
                                                                {/* <Slider {...settings}> */}
                                                                {
                                                                    rooms.map((room, i) => {
                                                                        return <div className="item-room" key={i}>
                                                                            <ItemRoom
                                                                                type={"horizontal"}
                                                                                model={room}
                                                                            />
                                                                        </div>
                                                                    })
                                                                }
                                                                {/* </Slider> */}
                                                            </div>
                                                        </div>
                                                    </Grid.Column>
                                                </Grid.Row>
                                                <Grid.Row>
                                                    <Grid.Column width={16}>
                                                        <CreateUpdateEventForm
                                                            usersMailSystem={usersMailSystem}
                                                            userGroups={userGroups}
                                                            optionsEventType={optionsEventType}
                                                            optionsEventRoomFormat={optionsEventRoomFormat}
                                                            optionsConference={optionsConference}
                                                            model={model}
                                                            errors={modelErrors}
                                                            setting={setting}
                                                            handleChange={this.handleChange}
                                                        />
                                                    </Grid.Column>
                                                </Grid.Row>
                                            </React.Fragment>
                                        }
                                        <Grid.Column width={16} textAlign="center">
                                            <div className="box-action">
                                                {
                                                    isEvent &&
                                                    <ViewButton
                                                        model={new ButtonModel({
                                                            text: t("common.ok"),
                                                            color: "blue",
                                                            onClick: (e) => this.onValidate(this.onUpdateEvent)
                                                        })}
                                                    />
                                                }
                                                <ViewButton
                                                    model={new ButtonModel({
                                                        text: t("common.cancel"),
                                                        color: "grey",
                                                    })}
                                                />
                                            </div>
                                        </Grid.Column>
                                    </Grid>
                                </Form>
                            </div>
                        </Container>
                    </div>
                </LayoutWithHeaderFooter>
            </React.Fragment>
        )
    }
}

ViewUpdateEvent.defaultProps = {
    onGetEventInfo: () => {
        console.error("Please provide Get Event action.")
        return null
    },
    onGetSetting: () => {
        console.error("Please provide Get Setting action.")
        return null
    },
    onGetConferenceList: () => {
        console.error("Please provide Get Conference action.")
        return null
    },
    onGetEventType: () => {
        console.error("Please provide Get Event Type action.")
        return null
    },
    onGetEventRoomFormat: () => {
        console.error("Please provide Get Room Format action.")
        return null
    },
    onUpdateEvent: () => {
        console.error("Please provide Update action.")
        return null
    },
    onGetUserMailSystem: () => {
        console.error("Please provide Get User Mail System action.")
        return null
    },
    onGetUserGroupList: () => {
        console.error("Please provide Get User Group action.")
        return null
    },
}

const enhance = compose(
    translate,
    withRouter,
)


export default enhance(ViewUpdateEvent)